import Scene_pub from './Scene_pub'
export default Scene_pub
